<template>
  <div class="transaction-container" :id="transaction.transactionId" :class="{'editable': isTransactionEditable}"
       v-on:[editTransactionEvent]="openEditCategory">
    <div class="transaction-row">
      <span class="edit-container" :class="{'wiggle': shouldWiggle}" v-if="isTransactionEditable">
        <img class="edit" :src="require('@/assets/pencil.svg')" />
      </span>
      <div class="name">{{ transaction.businessName }}</div>
    </div>
    <div class="amounts-row transaction-row">
      <div>{{ formatAmount(getTransactionAmount(transaction)) }}</div>
    </div>
    <div class="more-details">
      <img class="icon" :src="require('@/assets/subdirectory-arrow-left@3x.png')">
      <span>{{ formatDate(transaction.transactionDate) }}</span>
      <span class="business-name">{{ transaction.businessName }}</span>
      <span>{{ getTransactionPayment(transaction) }}</span>
      <span>{{ getTransactionAccount(transaction) }} </span>
    </div>
  </div>
</template>

<script>
import { mapActions } from 'vuex';
import TransactionDisplayUtils from '../../TransactionDisplayUtils.vue';
import Segment from '../../../../../../../../../Segment';
import ChangeTransactionCategoryPopup from '../../../current-month/components/cashflow-edit/edit-transaction/ChangeTransactionCategoryPopup.vue';
import ModalBus from '../../../../../../../../../event-bus/modal-bus';

export default {
  name: 'TransactionRow',
  mixins: [TransactionDisplayUtils],
  props: [
    'transaction',
    'canEditCategory',
    'categoryName',
    'categoryId',
  ],
  created() {
    if (this.shouldWiggle) {
      try {
        localStorage.setItem('riseup.editWasViewed', 'true');
      } catch (e) {
        // Do nothing - this can happen when someone is block this site from cookies and local storage
      }
    }
  },
  computed: {
    isTransactionEditable() {
      return this.canEditCategory;
    },
    editTransactionEvent() {
      return this.isTransactionEditable ? 'click' : null;
    },
    shouldWiggle() {
      let editWasViewed = true;
      try {
        editWasViewed = localStorage.getItem('riseup.editWasViewed');
      } catch (e) {
        // Do nothing - this can happen when someone is block this site from cookies and local storage
      }
      return !editWasViewed;
    },
  },
  methods: {
    ...mapActions('editTransaction', ['startEditingTransaction']),
    getTransactionPayment(transaction) {
      return transaction.paymentNumber > 0 ? `- תשלום${transaction.paymentNumber}/${transaction.totalNumberOfPayments}` : '';
    },
    openEditCategory() {
      Segment.trackUserInteraction('EditTransactionClicked', { businessName: this.transaction.businessName });
      this.startEditingTransaction({
        transaction: this.transaction,
        categoryName: this.categoryName,
        categoryId: this.categoryId,
      });
      ModalBus.$emit('open', {
        component: ChangeTransactionCategoryPopup,
        props: {},
      });
    },
  },
};
</script>

<style scoped lang="scss">
  @import '../../../../../../../../../../node_modules/base-ui/src/scss/riseup-colors';

  .transaction-container {
    --pencil-bg-color: $riseup_white_1;
    padding: 8px 10px 4px 4px;
    background-color: $riseup_gray_0;
    border-bottom: 1px solid $riseup_white;
    transition: background-color 1s ease;

    &.editable {
      cursor: pointer;
    }

    &:first-of-type {
      box-shadow: inset 0 2px 3px 0 rgba(155, 155, 155, 0.51);
    }

    &:last-of-type {
      border-bottom: none;
    }

    &.highlight {
      background-color: $riseup_gray_1;
    }

    .transaction-row {
      display: flex;
      height: 15px;
      font-size: 10px;
      line-height: 1;

      .edit-container {
        width: 16px;
        height: 16px;
        border-radius: 3px;
        background-color: var(--pencil-bg-color);
        margin-top: -2px;
        margin-left: 7px;

        &.wiggle {
          animation: fadein 1.5s ease-out;
          animation-iteration-count: 3;

          @keyframes fadein {
            50% {
              opacity: 0;
            }
          }
        }

        .edit {
          margin-right: 3px;
          margin-top: 3px;
          width: 10px;
          height: 10px;
        }
      }
    }

    .amounts-row {
      display: flex;
      padding-right: 90px;
      font-weight: bold;
    }

    .more-details {
      display: flex;
      white-space: nowrap;
      height: 18px;
      font-size: 10px;
      line-height: 1;
      color: $riseup_gray_3;

      span {
        overflow: hidden;
        padding-left: 2px;
      }

      .business-name {
        max-width: 126px;
      }

      .icon {
        margin-top: 2px;
        padding-left: 2px;
        height: 6px;
      }
    }
  }
</style>



// WEBPACK FOOTER //
// src/pages/responsive-pages/authenticated/navigation-pages/cashflow-app/cashflow-view/generic-components/cashflow-types/cashflow-types-base/TransactionRow.vue